import React, {useCallback, useEffect, useState} from 'react';
import {Alert, Button, CircularProgress, Stack, TextField, Typography} from '@mui/material';
import {Work} from '@mui/icons-material';

const PostToJobBoard = ({initialInstructions}) => {
    const [description, setDescription] = useState('');
    const [posting, setPosting] = useState(false);
    const [posted, setPosted] = useState(false);

    useEffect(() => {
        if (initialInstructions) {
            setDescription(initialInstructions);
        }
    }, [initialInstructions]);

    const handlePost = useCallback(() => {
        setPosting(true);
        // Fake posting for demo
        setTimeout(() => {
            setPosting(false);
            setPosted(true);
        }, 1500);
    }, []);

    if (posted) {
        return (
            <Stack p={2} spacing={2} alignItems="center" height="100%">
                <Alert severity="success" sx={{width: '100%'}}>
                    Your request has been posted to the job board. Experts will be notified and can reach out if
                    interested.
                </Alert>
                <Button variant="outlined" onClick={() => setPosted(false)}>
                    Post Another Request
                </Button>
            </Stack>
        );
    }

    return (
        <Stack p={2} spacing={2} height="100%">
            <Typography variant="body2" color="text.secondary">
                Share this ask with the SME network. Experts with relevant knowledge will be notified and can volunteer
                to review your product.
            </Typography>

            <TextField
                label="Description"
                placeholder="Describe what kind of expertise you're looking for..."
                multiline
                minRows={4}
                size="small"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                fullWidth
                required
            />

            <Alert severity="info" sx={{fontSize: '0.8rem'}}>
                <strong>Note:</strong> Your request will be visible to all approved SMEs. Do not include
                program-restricted information in the description.
            </Alert>

            <Button
                variant="contained"
                startIcon={posting ? <CircularProgress size={16} color="inherit"/> : <Work/>}
                onClick={handlePost}
                disabled={posting || !description.trim()}
                fullWidth
            >
                {posting ? 'Posting...' : 'Post to Job Board'}
            </Button>
        </Stack>
    );
};

export default PostToJobBoard;
